(function() {
  var _scrollY = 0;
  var _locked = false;

  // Cria overlay
  var _overlay = document.createElement('div');
  _overlay.className = 'cart-overlay';
  document.body.appendChild(_overlay);

  // Intercepta classList.add/remove nativamente
  var origAdd = DOMTokenList.prototype.add;
  var origRemove = DOMTokenList.prototype.remove;

  DOMTokenList.prototype.add = function() {
    var tokens = Array.prototype.slice.call(arguments);
    if (this === document.body.classList && tokens.indexOf('no-mobile-scroll') !== -1 && !_locked) {
      _locked = true;
      _scrollY = window.scrollY || document.documentElement.scrollTop;
      document.body.style.top = '-' + _scrollY + 'px';
      document.body.style.position = 'fixed';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      _overlay.classList.add('is-visible');
    }
    return origAdd.apply(this, arguments);
  };

  DOMTokenList.prototype.remove = function() {
    var tokens = Array.prototype.slice.call(arguments);
    var result = origRemove.apply(this, arguments);
    if (this === document.body.classList && tokens.indexOf('no-mobile-scroll') !== -1 && _locked) {
      _locked = false;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo({ top: _scrollY, left: 0, behavior: 'instant' });
      _overlay.classList.remove('is-visible');
    }
    return result;
  };

    // Listener do botão da sacola e botão X
  var CART_SELECTOR = '.header__action-item--cart .header__cart-toggle';

  window.addEventListener('click', function(e) {
    var target = e.target.closest(CART_SELECTOR);
    var closeBtn = e.target.closest('.mini-cart__header-close');

    if (!target && !closeBtn) return;

    e.stopPropagation();
    e.preventDefault();

    var mc = document.getElementById('mini-cart');
    if (!mc) return;

    var isOpen = mc.getAttribute('aria-hidden') === 'false';
    if (isOpen) {
      if (mc.contains(document.activeElement)) {
        document.activeElement.blur();
      }
      mc.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('no-mobile-scroll');
      if (target) {
        target.setAttribute('aria-expanded', 'false');
        target.focus({ preventScroll: true });
      }
    } else {
      mc.setAttribute('aria-hidden', 'false');
      document.body.classList.add('no-mobile-scroll');
      if (target) target.setAttribute('aria-expanded', 'true');
    }
  }, true);

  // Neutraliza altura dinâmica do tema
  function neutralizeJsHeight() {
    var miniCart = document.querySelector('.mini-cart');
    if (!miniCart) return;
    new MutationObserver(function() {
      if (miniCart.getAttribute('aria-hidden') === 'false') {
        miniCart.style.maxHeight = '';
        var content = miniCart.querySelector('.mini-cart__content');
        if (content) content.style.maxHeight = '';
      }
    }).observe(miniCart, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', neutralizeJsHeight);
  } else {
    neutralizeJsHeight();
  }
})();
